/**************** Translation Manager ********************
 * This class can accept one or more translation sources, key map & defaultDeictionary
 * Please note that all the parameters are optional.
 * Example usage:

    var translationUrl = "translations.json";

    var translationDictionary = {
    "componentTitle1": "Object picker",
    "launchButtonText": "Select",
    "browseDevice": "Browse device photos",
    "submit1": "Select"
    };

    var translationSource = [
        {
            "type": "URL",
            "value": translationUrl
        },
        {
            "type": "DICTIONARY",
            "value": translationDictionary
        }
    ];

    var translationKeyMap = {
	  "componentTitle": "componentTitle1",
      "submit": "submit1"
    };
    
    var defaultTranslationDictionary = {
    "componentTitle": "Add attachment",
    "launchButtonText": "Add attachment",
    "browseDevice": "Browse device photos",
    "submit": "Add"
    };

    var tm = new TranslationManager(translationSource, translationKeyMap, defaultTranslationDictionary);

    //To get translation string for translation key
    var translationString = tm.translate(translationKey);

 * *******************************************************/
import getRequestAsPromise from '../xhttp/getRequestAsPromise.js';
export default class TranslationManager {
    constructor(translationSource, translationKeyMap, defaultTranslationDictionary) {
        this.translationSource = translationSource || [];
        //this.translationDictionary = translationDictionary;
        this.translationKeyMap = translationKeyMap || {};
        this.defaultTranslationDictionary = defaultTranslationDictionary || {};
        /*if(this.translationUrl){
            this.loadTranslationsFromUrl();
        }*/
        this._translationsParts = {};
    }

    refreshTranslations() {
        if (this.translationSource && this.translationSource.length) {
            var result = Object.assign({}, this.translationDictionary);
            for (var i = 0; i < this.translationSource.length; i++) {
                var t = {};
                if (this.translationSource[i].type == "URL") {
                    t = this.getTranslationsFromUrl(this.translationSource[i].value);
                } else if (this.translationSource[i].type == "DICTIONARY") {
                    t = this.translationSource[i].value;
                }
                result = Object.assign(result, t);
            }

            this.translationDictionary = result;
        }
    }

    addTranslationDictionary(dictionary) {
        this.translationSource.push({
            "type": "DICTIONARY",
            "value": dictionary
        });
        this.refreshTranslations();
    }

    addTranslationUrl(url) {
        this.translationSource.push({
            "type": "URL",
            "value": url
        });
        this.refreshTranslations();
    }

    setTranslationKeyMap(mapping) {
        this.translationKeyMap = mapping;
    }

    setTranslationSource(source) {
        this.translationSource = source;
        this.refreshTranslations();
    }

    async getTranslationsFromUrl(url) {
        var result = null;
        if (this._translationsParts[url]) {
            result = this._translationsParts[url];
        } else {
            result = await getRequestAsPromise("GET", url);
            result = result && JSON.parse(result) || {};
            this._translationsParts[url] = result;
        }
        return result;
    }

    translate(key) {
        var result = '';
        var mapKey = this.getMappedKey(key);
        if (this.translationDictionary && this.translationDictionary[mapKey]) {
            result = this.translationDictionary[mapKey];
        } else {
            result = this.defaultTranslationDictionary[key] || key;
        }
        return result;
    }

    getMappedKey(key) {
        var result = key;
        if (this.translationKeyMap && typeof this.translationKeyMap == 'object' && Object.keys(this.translationKeyMap).length) {
            result = this.translationKeyMap[key];
        }
        return result;
    }

}